import React from 'react';
import ErrorPage from '../src/pages/ErrorPage';

export default function Page() {
  return (
    <ErrorPage title="你好像迷路了 ..." description="查無頁面或頁面已被刪除" />
  );
}
